import React, { createContext, PropsWithChildren, useContext, useState } from 'react';

type SelectedIntakesContextState = {
  selectedIntakes: string[];
  clear: () => void;
  toggle: (id: string) => void;
};
const selectedIntakesContext = createContext<SelectedIntakesContextState | undefined>(undefined);

export function SelectedIntakesContextProvider({ children }: PropsWithChildren) {
  const [selectedIntakes, setSelectedIntakes] = useState<string[]>([]);

  const toggle = React.useCallback((id: string) => {
    setSelectedIntakes((prv) => {
      if (prv.includes(id)) return prv.filter((item) => item !== id);
      return [...prv, id];
    });
  }, []);
  const clear = React.useCallback(() => setSelectedIntakes([]), []);

  const state = React.useMemo(() => ({ selectedIntakes, toggle, clear }), [selectedIntakes, toggle, clear]);

  return <selectedIntakesContext.Provider value={state}>{children}</selectedIntakesContext.Provider>;
}

export function useSelectedIntakes() {
  const value = useContext(selectedIntakesContext);
  if (value === undefined) {
    throw new Error('useSelectedIntakes must be used within a SelectedIntakesContextProvider');
  }
  return value;
}
